module.exports = __webpack_public_path__ + "static/13-4fd831624d72b962161d01ee200e317a.jpg";